// extracted by mini-css-extract-plugin
export default {"header":"SectionHeader_header__lN3f2"};